import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagChipsComponent } from './tag-chips/tag-chips.component';
import { ColorPickerDirective } from 'ngx-color-picker';
import { MatBadgeModule } from '@angular/material/badge';
import { MatInputModule } from '@angular/material/input';
import { SharedTranslateModule } from '@app/shared/shared-translate.module';
import { MatDialogModule } from '@angular/material/dialog';
import { DataTableModule } from '@app/core/components/data-table/data-table.module';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialModule } from '../../lib/material.module';
import { AddTagComponent } from './add-tag/add-tag.component';
import { MatChipsModule } from '@angular/material/chips';
import { TagSettingsButtonComponent } from './tag-settings-button/tag-settings-button.component';
import { TagSettingsCardComponent } from './tag-settings-card/tag-settings-card.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TagDropdownComponent } from './tags-dropdown/tags-dropdown.component';
import { SharedModule } from '@app/shared/shared.module';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  declarations: [TagChipsComponent, AddTagComponent, TagSettingsButtonComponent, TagSettingsCardComponent, TagDropdownComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NgxPermissionsModule,
    SharedTranslateModule,
    MatChipsModule,
    DataTableModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatDialogModule,
    FormsModule,
    DragDropModule,
    MatProgressSpinnerModule,
    SharedModule,
    A11yModule,
    ReactiveFormsModule,
    MatBadgeModule,
    MatFormFieldModule,
    ColorPickerDirective,
    MatInputModule,
  ],
  exports: [TagChipsComponent, AddTagComponent, TagSettingsButtonComponent, TagSettingsCardComponent, TagDropdownComponent],
})
export class TagsModule { }
